module.exports = __webpack_public_path__ + "img/3c683302f04f6bf8777873f7d8edc244.png";